// src/routes/RecruiterRoutes.tsx
import React, { Suspense } from 'react';
import { Route } from 'react-router-dom';
import ProtectedRoute from '../auth/ProtectedRoute';
import Loader from '../components/Loader';
import recruiterRoutesConfig from './config/recruiterRoutesConfig';


const RecruiterRoutes = recruiterRoutesConfig.map(({ path, component: Component }) => (
  <Route
    key={path}
    path={path}
    element={
      <Suspense fallback={<Loader />}>
        <ProtectedRoute element={<Component />} allowedRoles={['Recruiter', 'HR', 'Accountant', 'Admin']} />
      </Suspense>
    }
  />
));
export default RecruiterRoutes;

